import { DeviceError, DeviceErrorCode } from '../../../errors/DeviceError'
import { LevelAddress, CommonAddress, NestedLevelAddress } from '../../../types/protocol'

const ADDRESS_LEVEL = [0x0600, 0x0a00, 0x0e00, 0x1200, 0x1600, 0x1a00, 0x1e00, 0x2200]

/**
 * TODO all need to
 */

// 鼠标键位地址
const KEY_ADDRESS_LEVEL = [
  0x0000, 0x0004, 0x0008, 0x000c, 0x0010, 0x0014, 0x0018, 0x001c, 0x0010, 0x0024, 0x0028, 0x002c,
  0x0030, 0x0034, 0x0038,
]

/**
 * 根据偏移量计算 真实的LevelAddress
 * @param offset 偏移量
 * @returns LevelAddress
 */
export const generateLevelAddress = (offset: number): LevelAddress => {
  const data = ADDRESS_LEVEL.map((level) => {
    const real = level + offset
    return [
      real & 0x000000ff,
      (real & 0x0000ff00) >> 8,
      (real & 0x00ff0000) >> 16,
      (real & 0xff000000) >> 24,
    ] as CommonAddress
  })
  return data as LevelAddress
}

export const generateKeyLevelAddress = (): NestedLevelAddress => {
  const data = ADDRESS_LEVEL.map((level) => {
    const key = KEY_ADDRESS_LEVEL.map((keyAddr) => {
      const real = level + keyAddr
      return [
        real & 0x000000ff,
        (real & 0x0000ff00) >> 8,
        (real & 0x00ff0000) >> 16,
        (real & 0xff000000) >> 24,
      ] as CommonAddress
    })
    return key as LevelAddress
  })
  return data as NestedLevelAddress
}

export const generateSensorModeAddress = (offset: number): NestedLevelAddress => {
  const data = ADDRESS_LEVEL.map((level) => {
    const real = level + offset
    const sensorMode = []
    for (let i = 0; i < 7; i++) {
      const sensorAddr = real + i
      sensorMode.push([
        sensorAddr & 0x000000ff,
        (sensorAddr & 0x0000ff00) >> 8,
        (sensorAddr & 0x00ff0000) >> 16,
        (sensorAddr & 0xff000000) >> 24,
      ] as CommonAddress)
    }
    return sensorMode as LevelAddress
  })
  return data as NestedLevelAddress
}

/**
 * 计算宏相关 真实的LevelAddress
 * @param offset 偏移量
 * @param packageNum 包数量
 * @param packageLen 包长度
 * @returns LevelAddress
 */
export const generateMacroAddressLevel = (
  offset: number,
  packageNum: number,
  packageLen: number = 0x1000,
): LevelAddress => {
  const data = [] as LevelAddress
  for (let i = 0; i < packageNum; i++) {
    const real = offset + i * packageLen
    data.push([
      real & 0x000000ff,
      (real & 0x0000ff00) >> 8,
      (real & 0x00ff0000) >> 16,
      (real & 0xff000000) >> 24,
    ] as CommonAddress)
  }
  return data as LevelAddress
}

// 宏单包地址
export const generateMacroPackageAddressLevel = (
  offset: CommonAddress,
  macroTotalLength: number,
  maxPackageLength: number = 24,
  maxMacroCount: number = 4 * 1024,
): LevelAddress => {
  if (macroTotalLength <= 0 || macroTotalLength > maxMacroCount) {
    throw new DeviceError(
      DeviceErrorCode.INVALID_PARAM,
      `The length of the macro (${macroTotalLength}) exceeds the allowed range (1 to ${maxMacroCount}).`,
    )
  }
  if (maxPackageLength <= 0) {
    throw new DeviceError(
      DeviceErrorCode.INVALID_PARAM,
      `The length of a single packet must be greater than 0.`,
    )
  }
  if (!Array.isArray(offset) || offset.length !== 4) {
    throw new DeviceError(
      DeviceErrorCode.INVALID_PARAM,
      `The offset must be a CommonAddress type (4-digit number array).`,
    )
  }

  const startAddr = (offset[3] << 24) | (offset[2] << 16) | (offset[1] << 8) | offset[0]

  const packageCount = Math.ceil(macroTotalLength / maxPackageLength)
  const packageAddresses: LevelAddress = []

  for (let i = 0; i < packageCount; i++) {
    const packageAddr = startAddr + i * maxPackageLength
    packageAddresses.push([
      packageAddr & 0x000000ff,
      (packageAddr & 0x0000ff00) >> 8,
      (packageAddr & 0x00ff0000) >> 16,
      (packageAddr & 0xff000000) >> 24,
    ] as CommonAddress)
  }

  return packageAddresses
}
